import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { Component, computed, inject, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingService } from '@base/services/loading';

@Component({
  selector: 'base-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'loadingBar',
  imports: [MatProgressBarModule],
})
export class LoadingBarComponent implements OnChanges {
  private _loadingService = inject(LoadingService);

  @Input() autoMode: boolean = true;

  protected mode = computed(() => this._loadingService.mode());
  protected progress = computed(() => this._loadingService.progress());
  protected show = computed(() => this._loadingService.show());

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On changes
   *
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    // Auto mode
    if ('autoMode' in changes) {
      // Set the auto mode in the service
      this._loadingService.setAutoMode(coerceBooleanProperty(changes.autoMode.currentValue));
    }
  }
}
